import { createUseStyles } from 'react-jss';

export const useHomeBusinessStyles = createUseStyles({
  bgBlueWhiteGradient: {
    background:
      'linear-gradient(0deg, rgba(255,255,255,255) 95%, rgba(0,50,160,1) 95%)',
    '@media (min-width: 1024px)': {
      background:
        'linear-gradient(0deg, rgba(255,255,255,255) 90%, rgba(0,50,160,1) 90%)',
    },
  },
});
